import React from 'react';
import type { Campaign } from '@/types/campaign';

interface CampaignDebugProps {
  devMode: boolean;
  campaign: Campaign | undefined;
  displayCampaign: Campaign | undefined;
  hasFullStructure: boolean;
  isLoading: boolean;
}

/**
 * Debug panel shown in development mode.
 */
export function CampaignDebug({
  devMode,
  campaign,
  displayCampaign,
  hasFullStructure,
  isLoading,
}: CampaignDebugProps) {
  if (!devMode) {
    return null;
  }

  return (
    <>
      {/* Loading message while waiting for campaign data */}
      {!hasFullStructure && !isLoading && (
        <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
          <p className="text-yellow-800">
            ⚠️ Campaign structure not available
          </p>
          <p className="text-sm text-yellow-600 mt-2">
            Navigate to this page from the Account page to see cold start optimization.
            <br />
            (Campaign data must be passed during navigation like the old frontend)
          </p>
        </div>
      )}

      {!hasFullStructure && isLoading && (
        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
          <p className="text-blue-800">
            ⏳ Loading campaign data...
          </p>
        </div>
      )}

      {/* Debug Info Panel */}
      <div className="mt-8 p-4 bg-gray-100 rounded-lg">
        <h3 className="text-lg font-semibold mb-2">🔧 Debug Info</h3>
        <pre className="text-xs bg-gray-800 text-white p-2 rounded overflow-auto">
          {JSON.stringify({ campaign, displayCampaign }, null, 2)}
        </pre>
      </div>
    </>
  );
}
